import { unwrap, type components } from "@sagot/api-client";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useApi } from "../../../../session/session-provider";
import { useWorkspaceId } from "../../../../session/workspace-context";
import { workflowKeys } from "../../../engage/workflows/use-workflows";
import { wsKeys, type WebhookOut } from "../../shared";

type ConnectorAuthIn = components["schemas"]["ConnectorAuthIn"];

/** `{header, value}` sets or replaces the authentication; `null` removes it. */
export type ConnectorAuthPatch = ConnectorAuthIn | null;

/**
 * Sets, replaces (`{header, value}`) or removes (`null`) the connector authentication of an endpoint. The answer shows the
 * header and its last four characters only; the endpoint lists (here and in the workflow builder) are refreshed.
 */
export function useConnectorAuthChange(webhookId: string): UseMutationResult<WebhookOut, unknown, ConnectorAuthPatch> {
  const api = useApi();
  const wsId = useWorkspaceId();
  const client = useQueryClient();
  return useMutation({
    mutationFn: (connector_auth: ConnectorAuthPatch) => unwrap(api.PATCH("/v1/webhooks/{webhook_id}", { params: { path: { webhook_id: webhookId } }, body: { connector_auth } })),
    onSuccess: () => Promise.all([client.invalidateQueries({ queryKey: wsKeys.webhooks(wsId) }), client.invalidateQueries({ queryKey: workflowKeys.endpoints(wsId) })]),
  });
}
